import { AppSettingsVar } from '../../../_project/settings';
import { getCookie } from './getCookie';
import { addAuthorization } from '../../../hooks/use-http';
import { joinApiBaseUrl } from './resolveRestUrl';
export const STAGED_UPLOAD_PREFIX = '__staged_upload__:';

export async function uploadStagedFile(file) {
  const fd = new FormData();
  fd.append('file', file, file.name || 'upload');

  const isImage = typeof file.type === 'string' && file.type.startsWith('image/');
  const path = isImage ? 'rest/image/upload/' : 'rest/file/upload/';
  const url = joinApiBaseUrl(path);

  let requestObject = {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRFToken': getCookie('csrftoken'),
    },
    body: fd,
  };

  if (AppSettingsVar.debug && url.replace(AppSettingsVar.base_url, '').startsWith('/rest/')) {
    requestObject = await addAuthorization(requestObject);
  }

  const response = await fetch(url, requestObject);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    const msg = err.errors?.[0] || err.detail || `Upload failed (${response.status})`;
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
  }
  const data = await response.json();
  if (data.id) {
    return data.id;
  }
  if (data.upload_ref) {
    return `${STAGED_UPLOAD_PREFIX}${data.upload_ref}`;
  }
  throw new Error('Upload response missing id or upload_ref');
}
